import {getRequest} from "../fetchWrapper";


/**
 * Récupération de la liste des pays.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getCountryList = (token) => {
    const url = `/api-v1/admin/country/list`
    return getRequest(url, token)
};